// Central content + navigation for the RDA Glasgow site.

export const ASSETS = {
  heroMain:
    "https://static.prod-images.emergentagent.com/jobs/6e569ba8-fe14-4938-93f1-2393a9b2b0c7/images/4b0938a16003a91c31495ff95a7020ec001ebc5285a2801059355d8a8cf10cbc.jpeg",
  horsesPaddock:
    "https://static.prod-images.emergentagent.com/jobs/6e569ba8-fe14-4938-93f1-2393a9b2b0c7/images/49daab50a56c56319dae0019c47c9d2190d639a2c6ea2de9eee70e264c020497.jpeg",
  facilityExterior:
    "https://static.prod-images.emergentagent.com/jobs/6e569ba8-fe14-4938-93f1-2393a9b2b0c7/images/dd6f9d35be69c5e7107791f1b2a21b6321f6271bbd81d4cea891013aa55caa24.jpeg",
  therapyCloseup:
    "https://static.prod-images.emergentagent.com/jobs/6e569ba8-fe14-4938-93f1-2393a9b2b0c7/images/3a3f2befff466896dd2746c1765d3e8d3320906b32c08abc45497202d4867063.jpeg",
  volunteering:
    "https://static.prod-images.emergentagent.com/jobs/6e569ba8-fe14-4938-93f1-2393a9b2b0c7/images/b963d1479c0f99b6930d861b150c912c4951ec9ca23ccc68b7736e4c0c9b4cd8.jpeg",
  logo:
    "https://static.prod-images.emergentagent.com/jobs/6e569ba8-fe14-4938-93f1-2393a9b2b0c7/images/02ce4fcfb0d31e0ea8d09da99050a38417bfc008020cc88ad62479ae0e519d84.jpeg",
};

export const CONTACT = {
  email: "rda@rdaglasgow.org",
  phone: "0141 945 1369",
  address: "Sandyflat, Caldercuilt Road, Summerston, Glasgow, G23 5NA",
  charityNo: "SC002041",
};

export const DONATE_MESSAGE =
  "Online donations coming soon — please contact us at rda@rdaglasgow.org in the meantime.";

// Primary nav shown inline on desktop.
export const PRIMARY_NAV = [
  { label: "About", to: "/about" },
  { label: "Riding & Therapy", to: "/riding-therapy" },
  { label: "Volunteering", to: "/volunteering" },
  { label: "Support Us", to: "/support-us" },
  { label: "Contact", to: "/contact" },
];

// Grouped under a "More" dropdown on desktop.
export const MORE_NAV = [
  { label: "Facility Hire", to: "/facility-hire" },
  { label: "Vacancies", to: "/vacancies" },
  { label: "Gallery", to: "/gallery" },
  { label: "News", to: "/news" },
];

// Full ordered list (used by the mobile drawer).
export const ALL_NAV = [
  { label: "About", to: "/about" },
  { label: "Riding & Therapy", to: "/riding-therapy" },
  { label: "Volunteering", to: "/volunteering" },
  { label: "Facility Hire", to: "/facility-hire" },
  { label: "Support Us", to: "/support-us" },
  { label: "Vacancies", to: "/vacancies" },
  { label: "Gallery", to: "/gallery" },
  { label: "News", to: "/news" },
  { label: "Contact", to: "/contact" },
];

// Seeded from rdaglasgow.org testimonials — verify wording with RDA before launch
export const TESTIMONIALS = [
  {
    quote:
      "Riding at RDA Glasgow has given me confidence I never knew I had — it's the highlight of my week.",
    name: "Kirsty",
    role: "Rider",
  },
  {
    quote:
      "Volunteering here is genuinely joyful. Seeing riders grow every session is why I keep coming back.",
    name: "Jill",
    role: "Volunteer",
  },
];
